/**
 * Extra looksmaxxing entry points at `/onboarding/looksmaxxing-{slug}`.
 * Same UX and tracking as `/onboarding/looksmaxxing`, except on successful
 * payment the standard "Purchase" pixel/server event is replaced by
 * {@link LOOKSMAXXING_CUSTOM_PURCHASE_EVENT_NAME} (see facebookTracking).
 */
export const LOOKSMAXXING_CUSTOM_PURCHASE_FUNNEL_SLUGS = ["custom"] as const

export const LOOKSMAXXING_CUSTOM_PURCHASE_EVENT_NAME =
  "purchase-looksmaxxing-custom" as const

function looksmaxxingCustomPurchaseFunnelBasePaths(): string[] {
  return LOOKSMAXXING_CUSTOM_PURCHASE_FUNNEL_SLUGS.map(
    (slug) => `/onboarding/looksmaxxing-${slug}`,
  )
}

export function pathnameIsLooksmaxxingCustomPurchaseFunnel(
  pathname: string,
): boolean {
  return looksmaxxingCustomPurchaseFunnelBasePaths().some(
    (base) => pathname === base || pathname.startsWith(`${base}/`),
  )
}
